import { render, staticRenderFns } from "./pwa_main_info.vue?vue&type=template&id=dda6f73a&scoped=true&"
import script from "./pwa_main_info.vue?vue&type=script&lang=js&"
export * from "./pwa_main_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda6f73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda6f73a')) {
      api.createRecord('dda6f73a', component.options)
    } else {
      api.reload('dda6f73a', component.options)
    }
    module.hot.accept("./pwa_main_info.vue?vue&type=template&id=dda6f73a&scoped=true&", function () {
      api.rerender('dda6f73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/pwa_main_info.vue"
export default component.exports